import group from './group'
import primary from './primary'
import mute from './mute'
import disabled from './disabled'
import dark from './dark'
import white from './white'
import simple from './simple'
import icon from './icon'
import subheader from './subheader'
import header from './header'
import newsletter from './newsletter'
import newsletterOnsubmit from './newsletterOnsubmit'
import portfolio from './portfolio'
import sideprojects from './sideprojects'
import filter from './filter'
import secondary from './secondary'

const button = {
  secondary,
  group,
  primary,
  mute,
  disabled,
  dark,
  white,
  simple,
  icon,
  header,
  subheader,
  newsletter,
  newsletterOnsubmit,
  portfolio,
  sideprojects,
  filter
}

export default button